module.exports = __webpack_public_path__ + "img/logo-light.81e692ef.svg";